<div class="p-2 bg-gray-50 min-h-screen">
  <!-- TABLE SECTION -->
  <div class=" ">
    <!-- TABLE HEADER -->
    <div class="flex justify-between items-center mb-4">
      <h3 class="text-lg font-semibold text-gray-800">{{ 'CREDIT_PROPOSED_DISB.TITLE' | translate }}</h3>
    </div>

    <!-- STATE -->
    @if (disbursementLoading) {
      <div class="text-sm text-gray-500 mb-2">{{ 'CREDIT_PROPOSED_DISB.LOADING' | translate }}</div>
    }

    @if (disbursementError) {
      <div class="text-sm text-red-600 mb-2">{{ disbursementError | translate }}</div>
    }

    <!-- TABLE -->
    <app-table
      [columns]="disbursementColumns"
      [data]="disbursementList"
      [actions]="disbursementActions"
      [enablePagination]="true"
      [pageSize]="10"
    >
    </app-table>
  </div>
</div>

<!-- VIEW POPUP -->
@if (showViewPopup && selectedRow) {
  <app-popup
    [(show)]="showViewPopup"
    title="CREDIT_PROPOSED_DISB.POPUP_TITLE"
    type="custom"
    width="w-full max-w-2xl"
  >
    <div class="space-y-4">
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div class="bg-gray-100 rounded-2xl px-4 py-3">
          <div class="text-xs text-gray-500">{{ 'CREDIT_PROPOSED_DISB.DISBURSEMENT_ID' | translate }}</div>

          <div class="text-sm font-medium text-[#13258f]">{{ selectedRow.prpsdDsbmntSeq }}</div>
        </div>

        <div class="bg-gray-100 rounded-2xl px-4 py-3">
          <div class="text-xs text-gray-500">{{ 'CREDIT_UPLOAD.CREDIT_PROPOSAL_ID' | translate }}</div>

          <div class="text-sm font-medium text-gray-800">{{ selectedRow.crdtPrpslSeq }}</div>
        </div>

        <div class="bg-gray-100 rounded-2xl px-4 py-3">
          <div class="text-xs text-gray-500">{{ 'QPR.INSTITUTION' | translate }}</div>

          <div class="text-sm font-medium text-gray-800">{{ selectedRow.institutionNm }}</div>
        </div>

        <div class="bg-gray-100 rounded-2xl px-4 py-3">
          <div class="text-xs text-gray-500">{{ 'CREDIT_PROPOSED_DISB.INSTALLMENT_NO' | translate }}</div>

          <div class="text-sm font-medium text-gray-800">
            {{ selectedRow.installmentNo ?? '-' }}
          </div>
        </div>

        <div class="bg-gray-100 rounded-2xl px-4 py-3">
          <div class="text-xs text-gray-500">{{ 'CREDIT_PROPOSED_DISB.SCHEDULED_MONTH' | translate }}</div>

          <div class="text-sm font-medium text-gray-800">
            <span dir="ltr">{{ selectedRow.schMth ? (selectedRow.schMth | date: 'dd-MMM-yyyy') : '-' }}</span>
          </div>
        </div>

        <div class="bg-gray-100 rounded-2xl px-4 py-3">
          <div class="text-xs text-gray-500">{{ 'CREDIT_PROPOSED_DISB.PROPOSED_AMOUNT' | translate }}</div>

          <div class="text-sm font-medium text-gray-800">
            {{ selectedRow.prpsdDsbmntAmnt | number: '1.0-0' }}
          </div>
        </div>

        <div class="bg-gray-100 rounded-2xl px-4 py-3">
          <div class="text-xs text-gray-500">{{ 'COMMON.STATUS' | translate }}</div>

          <div class="text-sm font-medium text-gray-800">{{ selectedRow.statusLabel | translate }}</div>
        </div>

        <div class="bg-gray-100 rounded-2xl px-4 py-3">
          <div class="text-xs text-gray-500">{{ 'CREDIT_PROPOSED_DISB.CLIENT_ID' | translate }}</div>

          <div class="text-sm font-medium text-gray-800">{{ selectedRow.clntSeq ?? '-' }}</div>
        </div>
      </div>

      <div class="flex flex-col-reverse sm:flex-row sm:justify-end gap-3 border-t border-gray-200 pt-4">
        <button
          type="button"
          class="w-full sm:w-auto px-6 py-2.5 rounded-lg border border-gray-300 bg-white text-gray-700 font-medium hover:bg-gray-50"
          (click)="closeViewPopup()"
        >
          {{ 'COMMON.CLOSE' | translate }}
        </button>

        <button
          type="button"
          class="w-full sm:w-auto px-6 py-2.5 rounded-lg bg-indigo-600 text-white font-medium hover:bg-indigo-700"
          (click)="openDisbursementNote(selectedRow)"
        >
          {{ 'CREDIT_PROPOSED_DISB.OPEN_DISBURSEMENT_NOTE' | translate }}
        </button>
      </div>
    </div>
  </app-popup>
}
